import { useParams } from 'react-router-dom'
import useDashboard from '@/pages/Dashboards/hooks/useDashboard.ts'
import MainLayout from '@/shared/Layouts/MainLayout'
import css from './dashboardScreen.module.css'
import NavigationBreadcrumbs from '@/navigation/components/NavigationBreadcrumbs'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import SettingsIcon from '@/assets/icons/settingsIcon.svg?react'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { useRef, useState } from 'react'
import CreateWidgetSidePage from '@/pages/Dashboards/components/CreateWidgetSidePage'
import DashboardGrid from '@/pages/Dashboards/pages/DashboardScreen/DashboardGrid'
import dashboardsConfig from '@/pages/Dashboards/dashboards.config.ts'
import useViewportWidth from '@/shared/hooks/useViewportWidth.ts'
import useWidgetMoveAndResize from '@/pages/Dashboards/hooks/useWidgetMoveAndResize.ts'
import WidgetCard from '@/pages/Dashboards/pages/DashboardScreen/WidgetCard'
import DashboardPlayerControls from '@/pages/Dashboards/pages/DashboardScreen/DashboardPlayerControls'
import useTitle from '@/shared/hooks/useTitle'

const DashboardScreen = () => {
  const id = useParams().id
  const dashboard = useDashboard(+id)
  const [createWidgetSidePageOpen, setCreateWidgetSidePageOpen] = useState(false)
  useTitle(dashboard?.name ? `Дашборд — ${dashboard.name}` : 'Дашборд')

  const dashboardRef = useRef<HTMLDivElement>()
  const viewportWidth = useViewportWidth()
  const widgetMoveAndResizeCtrl = useWidgetMoveAndResize({
    selectedDashboardId: dashboard.id,
    dashboardRef,
    gridStep: dashboardsConfig.gridStep,
    viewportWidth,
  })

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className={css.mainCard}>
          <div className="flex-lines gap16">
            <NavigationBreadcrumbs
              withBackButton={true}
              lastMatch={{ pathname: '/', handle: { crumb: () => dashboard.name } } as any}
            />
            <div className="inline-flex-gap flex-space-between">
              <div className="inline-flex-gap gap12">
                <h3 className="text-heading-3">{dashboard.name}</h3>
                <Button size="default" type="default" buttonType="button" icon={<SettingsIcon />} onClick={() => {}} />
                <CreateEntityButton
                  onClick={() => setCreateWidgetSidePageOpen(true)}
                  text="Добавить виджет"
                  type="default"
                />
              </div>
              <DashboardPlayerControls />
            </div>
          </div>
          <SeparateLine />
          <div style={{ flex: 1, position: 'relative' }} ref={dashboardRef}>
            {widgetMoveAndResizeCtrl.data.isMoving && <DashboardGrid gridStep={dashboardsConfig.gridStep} />}
            <div className={css.dashboardAutoalignHint} ref={widgetMoveAndResizeCtrl.refs.autoalignHintRef} />
            {dashboard.widgets.map((c) => (
              <WidgetCard
                key={c.id}
                dashboardId={dashboard.id}
                onMove={widgetMoveAndResizeCtrl.handlers.handleMove}
                onMoveFinish={widgetMoveAndResizeCtrl.handlers.handleMoveFinish}
                viewport={viewportWidth}
                component={c}
              />
            ))}
          </div>
        </div>
      </div>
      <CreateWidgetSidePage
        open={createWidgetSidePageOpen}
        onClose={() => setCreateWidgetSidePageOpen(false)}
        dashboardId={dashboard.id}
      />
    </MainLayout>
  )
}

export default DashboardScreen
